// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__30lXv","head":"Table_head__2QHBx","col":"Table_col__28DlT"};